import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { hasLog, normalizeLog } from '../../../utils/normalize-log';
import { Lookups, WEBSITE_KEYS_LOOKUP, WebsiteKeys } from '@ag-common-lib/public-api';
import { ChangesHistoryGridService } from 'ag-common-svc/lib/components/changes-history-grid/changes-history-grid.service';

@Component({
  selector: 'ag-shr-change-log-websites',
  templateUrl: './change-log-websites.component.html',
  styleUrls: ['./change-log-websites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogWebsitesComponent {
  @Input() log: Delta;

  protected readonly websitesKeys = [WebsiteKeys.url, WebsiteKeys.websiteType];
  protected readonly normalizeLog = normalizeLog;
  protected readonly hasLog = hasLog;
  protected readonly websitesLookup = WEBSITE_KEYS_LOOKUP;

  constructor(private changesHistoryGridService: ChangesHistoryGridService) {}

  getLookup(key: WebsiteKeys) {
    switch (key) {
      case WebsiteKeys.websiteType:
        return this.changesHistoryGridService.getLookupByName(Lookups.WebsiteTypes);

      default:
        return null;
    }
  }
}
